import type { RevealStatus } from "@/types";

export type ChatRevealUiInput = {
  hasRevealResult?: boolean;
  chatRevealed?: boolean;
  revealStatus?: RevealStatus;
  revealRequestedByMe?: boolean;
  revealRequestedByPeer?: boolean;
  localRevealPending?: boolean;
};

export type ChatRevealUiState = {
  revealed: boolean;
  requestReceived: boolean;
  requestPending: boolean;
  banner: "sent" | "received" | null;
};

export function chatRevealUiState(input: ChatRevealUiInput): ChatRevealUiState {
  const revealed =
    Boolean(input.hasRevealResult) ||
    Boolean(input.chatRevealed) ||
    input.revealStatus === "revealed";
  const requestReceived =
    !revealed &&
    Boolean(
      input.revealRequestedByPeer || input.revealStatus === "pending_peer",
    );
  const requestPending =
    !revealed &&
    !requestReceived &&
    Boolean(
      input.localRevealPending ||
        input.revealRequestedByMe ||
        input.revealStatus === "requested",
    );

  return {
    revealed,
    requestReceived,
    requestPending,
    banner: requestReceived ? "received" : requestPending ? "sent" : null,
  };
}
